@import '../theme';

.errorContainer:hover {
    .copyInfo {
        display: block;
    }
}

.copyInfo {
    display: none;
    position: fixed;
    top: 0;
    left: 50%;
    background-color: white;
    padding: 8px;
    color: black;
    border-radius: 4px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.successMessage {
    background-color: @primaryColor !important;
}

.checkIcon {
    margin-right: @margin;
}

.errorTitle {
    word-wrap: break-word;
    white-space: break-spaces;
}
